module.exports = __webpack_public_path__ + "static/media/profile-1.85829be2.jpeg";